import { PersistedStateKeys } from '../enums';

export const getIsDeveloperModeEnabled = (): boolean => {
  const localStringBool = localStorage.getItem(PersistedStateKeys.IsDeveloperModeEnabled);
  if (!localStringBool) return false;
  return JSON.parse(localStringBool);
};

// Utilities that only execute while in dev mode.
// NOTE: Use sparingly and only leave behind what is necessary for future development.
export const DevMode = {
  // eslint-disable-next-line
  consoleLog: (message?: any, ...optionalParams: any[]): void => {
    if (!getIsDeveloperModeEnabled()) return;
    console.log(message, optionalParams);
  },

  callback: (callback: () => void): void => {
    if (!getIsDeveloperModeEnabled()) return;
    callback();
  },
};
